import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: '/'
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/home.vue')
    },
    {
      path: '',
      name: 'Home',
      component: () => import('../views/home.vue')
    },
    {
      path: '/projects',
      name: 'Projects',
      component: () => import('../views/projects.vue')
    },
    {
      path: '/prereview',
      name: 'PreReview',
      component: () => import('../views/pre-review.vue')
    },
    {
      path: '/aboutbytedance',
      name: 'AboutBytedance',
      component: () => import('../views/about-bytedance.vue')
    }
  ]
})